import { useState, useEffect } from "react";
import {
  Tooltip,
  Typography,
  Box,
  IconButton,
  InputBase,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseOrdergifts } from "./UseOrdergifts";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../../components/CustomPagination";
import ProgressCom from "../../../components/ProgressCom";
import Detail from "../../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseMyPC } from "../../../hooks/UseMyPC";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteRow from "../../../components/DeleteRow";
import { deCapitalizeFirstLetter, toMoney } from "../../../util/Utils";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import EditIcon from "@mui/icons-material/Edit";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";

export default function Ordergifts() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const { updateOrdergifts, getOrdergiftsList, deleteOrdergifts } =
    UseOrdergifts();
  const navigate = useNavigate();

  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const [openDialog, setOpenDialog] = useState({
    show: false,
    model: undefined,
  });

  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("rowNO");
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const [productRes, setProductRes] = useState();
  const [progress, setProgress] = useRecoilState(rsProgress);

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getOrdergiftsList(
      myPc,
      search,
      (products) => {
        setProductRes(products);
      },
      true
    );
  }, [myPc]);

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }
  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/ordergifts/addOrdergifts", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowNO",
      width: 100,
      align: "center",
      headerName: "الویت",
      headerAlign: "center",
    },
    {
      field: "giftName",
      headerName: "هدیه",
      width: 230,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.giftName}
          </Typography>
        );
      },
    },
    {
      field: "filter",
      headerName: "فیلتر",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.filter ? cellValues.row.filter : ""}
          </Typography>
        );
      },
    },
    {
      field: "minPayment",
      headerName: "حداقل خرید",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.minPayment ? toMoney(cellValues.row.minPayment) : 0}
          </Typography>
        );
      },
    },
    {
      field: "minOrderItems",
      headerName: "اقلام",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.minOrderItems
              ? toMoney(cellValues.row.minOrderItems)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "isActive",
      headerName: "وضعیت",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.isActive ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 200,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {cellValues.row.isActive ? (
              <Tooltip title="غیرفعال">
                <span>
                  <IconButton
                    onClick={() => {
                      let send = {
                        id: cellValues.row.id,
                        rowNO: cellValues.row.rowNO,
                        giftName: cellValues.row.giftName,
                        giftID: cellValues.row.giftID,
                        isActive: false,
                        minPayment: cellValues.row.minPayment,
                        minOrderItems: cellValues.row.minOrderItems,
                      };
                      setOpenDialog({
                        show: true,
                        model: send,
                        name: "غیرفعال",
                      });
                    }}
                  >
                    <CloseIcon fontSize="small" sx={{ color: "red" }} />
                  </IconButton>
                </span>
              </Tooltip>
            ) : (
              <Tooltip title="فعال">
                <span>
                  <IconButton
                    onClick={() => {
                      let send = {
                        id: cellValues.row.id,
                        rowNO: cellValues.row.rowNO,
                        giftName: cellValues.row.giftName,
                        giftID: cellValues.row.giftID,
                        isActive: true,
                        minPayment: cellValues.row.minPayment,
                        minOrderItems: cellValues.row.minOrderItems,
                      };

                      setOpenDialog({
                        show: true,
                        model: send,
                        name: "فعال",
                      });
                    }}
                  >
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            )}
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.productName,
                    giftId: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());

                  return navigate("/ordergifts/editOrdergifts", {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowNO: cellValues.row.rowNO - 1,
                  giftName: cellValues.row.giftName,
                  giftID: cellValues.row.giftID,
                  isActive: cellValues.row.isActive,
                  minPayment: cellValues.row.minPayment,
                  minOrderItems: cellValues.row.minOrderItems,
                };
                if (cellValues.row.rowNO - 1 == 0) {
                  return;
                } else {
                  setProgress(true);
                  updateOrdergifts(model, (callback) => {
                    getOrdergiftsList(
                      myPc,
                      search,
                      (products) => {
                        setProductRes(products);
                      },
                      false
                    );
                  });
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowNO: cellValues.row.rowNO + 1,
                  giftName: cellValues.row.giftName,
                  giftID: cellValues.row.giftID,
                  isActive: cellValues.row.isActive,
                  minPayment: cellValues.row.minPayment,
                  minOrderItems: cellValues.row.minOrderItems,
                };
                if (
                  cellValues.row.rowNO + 1 ==
                  productRes.products.length + 1
                ) {
                  return;
                } else {
                  setProgress(true);
                  updateOrdergifts(model, (callback) => {
                    getOrdergiftsList(
                      myPc,
                      search,
                      (products) => {
                        setProductRes(products);
                      },
                      false
                    );
                  });
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/ordergifts" }],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog.show}
        onClose={() => setOpenDialog({ ...openDialog, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          آیا از {openDialog.name} کردن هدیه اطمینان دارید ؟
        </DialogTitle>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() =>
              updateOrdergifts(openDialog.model, (callback) => {
                setOpenDialog({ ...openDialog, show: false });
                getOrdergiftsList(
                  myPc,
                  search,
                  (products) => {
                    setProductRes(products);
                  },
                  false
                );
              })
            }
          >
            بله
          </Button>
          <Button
            color="secondary"
            onClick={() => setOpenDialog({ ...openDialog, show: false })}
          >
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      {productRes ? (
        <DataGrid
          className="ltr-grid"
          disableVirtualization
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={productRes.pageCondition.pageCount}
          paginationMode="server"
          page={productRes.pageCondition.page - 1}
          rows={productRes.products}
          Pagination
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            productRes?.pageCondition.totalItemCount
              ? productRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              isLtr: true,
              //   nofab: true,
              newFunc: newFunc,
              rowCount: productRes?.pageCondition.totalItemCount
                ? productRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}

      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"هدیه سفارش"}
        callback={() => {
          setProgress(true);
          deleteOrdergifts(deleteState.giftId, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
